import Message from './message';

function message(props) {
  return new Message(props);
}

export default message;


//////////////////
// WEBPACK FOOTER
// ./~/codeages-design/src/lib/message/index.js
// module id = 556
// module chunks = 9